import colors from "constants/colors";
import { EventRegistrationStatus } from "@bindeleddet/core/types";

const GREY = "#b4b6b8";
const YELLOW = "#fcf4dc";

export const COLORS_PER_STATUS: Record<EventRegistrationStatus, string> = {
  AVAILABLE: colors.green,
  FULL: colors.red,
  NOT_OPEN: colors.blue,
  NOT_RELEVANT: GREY,
  REGISTERED: colors.green,
  REGISTERED_FOR_WAITLIST: YELLOW,
  WAITLIST_AVAILABLE: colors.green,
  BANNED: colors.red,
  EXTERNAL_BOOKING: colors.blue,
};
